import type { Crop } from './salesContent';

export const bonuses = [
  {
    label: 'Bono 1',
    title: '25 Escenarios de Simulación',
    body: 'Casos preparados para entrenar: RCP, DEA, atragantamiento, hemorragias, traumatismos, convulsiones y otras emergencias.',
    includesLabel: 'Cada escenario incluye:',
    includesText: 'Objetivo + preparación + consigna + acciones esperadas + errores críticos + checklist + debriefing',
    list: [] as string[],
    extras: [] as string[],
    highlight: 'Elegís → preparás → simulás → evaluás.',
    crop: { x: 105, y: 875, w: 235, h: 280 } as Crop,
  },
  {
    label: 'Bono 2',
    title: 'Pack Profesional de Evaluaciones',
    body: 'Dejá de crear una evaluación nueva cada vez que das un curso.',
    includesLabel: 'Incluye:',
    includesText: '',
    list: ['Banco de preguntas', 'Evaluaciones', 'Claves de respuesta', 'Rúbricas', 'Checklists de habilidades', 'Fichas de seguimiento'],
    extras: [],
    highlight: 'Para evaluar: conocimiento + decisión + ejecución',
    crop: { x: 335, y: 875, w: 230, h: 280 } as Crop,
  },
  {
    label: 'Bono 3',
    title: '10 Clases Listas para Dictar',
    body: 'El bono pensado para ahorrarte horas de preparación.',
    includesLabel: 'Cada clase incluye:',
    includesText: 'Objetivos + duración + materiales + explicación + demostración + práctica + simulación + evaluación + cierre',
    list: [],
    extras: ['Clase Express — 60 minutos', 'Taller Práctico — 2 horas', 'Jornada Intensiva — 6/8 horas'],
    highlight: 'Abrís → preparás → adaptás → dictás.',
    crop: { x: 560, y: 875, w: 225, h: 280 } as Crop,
  },
  {
    label: 'Bono 4',
    title: 'Kit Visual e Imprimible para el Aula',
    body: 'Dejá de diseñar desde cero el material de apoyo.',
    includesLabel: 'Incluye:',
    includesText: '',
    list: ['Infografías', 'Algoritmos visuales', 'Fichas de bolsillo', 'Pósters', 'Hojas resumen', 'Tarjetas de repaso'],
    extras: [],
    highlight: 'Proyectar + imprimir + explicar + entregar + reforzar',
    crop: { x: 780, y: 875, w: 225, h: 280 } as Crop,
  },
  {
    label: 'Bono 5',
    title: 'Pack de Gestión Profesional del Instructor',
    body: 'Organizá tu capacitación antes, durante y después.',
    includesLabel: 'Incluye:',
    includesText: '',
    list: [
      'Checklists de preparación',
      'Inventario de materiales',
      'Registro de asistencia',
      'Fichas de capacitación',
      'Organización de estaciones',
      'Encuestas de satisfacción',
      'Control de equipamiento',
      'Plantillas de seguimiento',
      'Modelos de constancias de participación',
    ],
    extras: [],
    highlight: 'Antes del curso → durante → después',
    crop: { x: 1000, y: 875, w: 235, h: 280 } as Crop,
  },
];